/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useRouter } from "next/router";
import styled, { css } from "styled-components";
import Link from "next/link";
import { isHostLaunchedMicrosite } from "utils";
import useIsDesktop from "hooks/useIsDesktop";
import ApnaViLogo from "assets/svgs/ApnaViLogo";
import ApnaLogo from "../ApnaLogo/ApnaLogo";
import media, { mediaMaxWidth } from "../../utils/mediaQuery";
import useBranchIoLinkGeneration from "../../utils/BranchIO";
import Button from "../Buttons/Button";
import {
	BRANCH_APP_DOWNLOAD_CAMPAIGNS,
	GOOGLE_CLOUD_STORAGE_BASE_URL,
	MICROSITES,
} from "../../utils/constants";
import { getUrlPath } from "../../utils/helpers";

const Header = ({
	hideHeading = false,
	heading,
	source,
	id,
	headerBgColor,
	rightActionBar,
	headerColor,
	hideBrandLines,
	cityDropdown,
	customUtmMedium,
	headerSeperator,
	sticky = false,
	hideHeaderTitleOnMobile = false,
}) => {
	const isDesktop = useIsDesktop();
	const router = useRouter();
	// eslint-disable-next-line @typescript-eslint/naming-convention
	const { utm_source, utm_medium, utm_campaign } = router.query;

	const [url] = useBranchIoLinkGeneration({
		campaign: BRANCH_APP_DOWNLOAD_CAMPAIGNS.playStoreIcon,
		section: "Header",
		pageType: source,
		customUtmMedium,
	});

	const [getAppUrl] = useBranchIoLinkGeneration({
		campaign: BRANCH_APP_DOWNLOAD_CAMPAIGNS.downloadAppCTA,
		section: "Header",
		pageType: source,
		customUtmMedium,
	});

	const logoURl = `/${utm_source ? `?utm_source=${utm_source}&` : ""}${
		utm_medium ? `utm_medium=${utm_medium}&` : ""
	}${utm_campaign ? `utm_campaign=${utm_campaign}` : ""}`;

	const onLogoclick = () => {
		if (router.asPath.includes("/employer/")) {
			import("../../utils/Mixpanel").then((Mixpanel) => {
				Mixpanel.default.track("Logo Header Click", {
					page: getUrlPath(),
				});
			});
		}
	};

	const onGooglePlayIconClick = () => {
		import("../../utils/Mixpanel").then((Mixpanel) => {
			Mixpanel.default.track("Google Play Icon Click", {
				"Profile URL": typeof window !== "undefined" && window.location.href,
				Source: source,
				Section: "Header",
				page: getUrlPath(),
			});
		});
	};

	const onGetAppClick = () => {
		import("../../utils/Mixpanel").then((Mixpanel) => {
			Mixpanel.default.track("Get App Button Click", {
				"Profile URL": typeof window !== "undefined" && window.location.href,
				Source: source,
				Section: "Header",
				page: getUrlPath(),
			});
		});
	};

	const hostVendor = isHostLaunchedMicrosite();
	const isHostVendorVi = hostVendor ? hostVendor === MICROSITES.VI : false;

	return (
		<MainContainer sticky={sticky}>
			<HeaderContainer
				id={id}
				bgColor={headerBgColor}
				headerSeperator={headerSeperator}
			>
				<HeaderWrapper>
					<HeaderLogoTextContainer>
						<HeaderLogoContainer>
							<Link href={logoURl} passHref>
								<a onClick={onLogoclick}>
									{isHostVendorVi && !isDesktop ? (
										<ApnaViLogo />
									) : (
										<ApnaLogo />
									)}
								</a>
							</Link>
						</HeaderLogoContainer>
						<HeaderTextContainer>
							{!hideHeading && (
								<HeaderText
									headerColor={headerColor}
									hideHeaderTitleOnMobile={hideHeaderTitleOnMobile}
								>
									{heading || "The Biggest Job Group in India"}
								</HeaderText>
							)}
						</HeaderTextContainer>
					</HeaderLogoTextContainer>
					<HeaderPlayStoreLogoContainer>
						{!rightActionBar && !cityDropdown ? (
							<PlayStoreLink
								href={url}
								id="playstore-header-link"
								target="_blank"
								rel="noopener noreferrer"
								onClick={onGooglePlayIconClick}
							>
								<Image
									src={`${GOOGLE_CLOUD_STORAGE_BASE_URL}/website/play-store-badge.png`}
									alt="Apna Play Store Image Link"
									loading="lazy"
								/>
							</PlayStoreLink>
						) : null}
						{!rightActionBar && !cityDropdown && !isHostVendorVi ? (
							<GetAppButton
								href={getAppUrl}
								id="playstore-header-link"
								target="_blank"
								rel="noopener noreferrer"
								as="a"
								onClick={onGetAppClick}
							>
								Get App
							</GetAppButton>
						) : null}
						{cityDropdown && cityDropdown}
						{rightActionBar && rightActionBar}
					</HeaderPlayStoreLogoContainer>
				</HeaderWrapper>
			</HeaderContainer>
			{!hideBrandLines && (
				<BrandLinesContainer>
					<BrandLines backgroundColor="#2bb793" />
					<BrandLines backgroundColor="#83bde4" />
					<BrandLines backgroundColor="#ffd166" />
				</BrandLinesContainer>
			)}
		</MainContainer>
	);
};

// Styles
const HeaderWrapper = styled.div`
	margin: 0 auto;
	display: flex;
	align-items: center;
	justify-content: space-between;

	${media.extraSmall`
        max-width: 100%;
    `};
	${media.small`
        max-width: 100%;
    `};
	${media.medium`
        max-width: 100%;
    `};
	${media.large`
        max-width: 960px;
    `};
	${media.extraLarge`
        max-width: 1140px;
    `};

	${mediaMaxWidth.large`
		text-align: center;
	`}
`;
const BrandLinesContainer = styled.div`
	display: flex;

	${mediaMaxWidth.small`
        display: none;
    `}
`;
const BrandLines = styled.div`
	height: 6px;
	width: 100%;
	background-color: ${({ backgroundColor }) => backgroundColor};
`;
const HeaderPlayStoreLogoContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-evenly;
`;
const PlayStoreLink = styled.a``;

const GetAppButton = styled(Button)`
	height: 30px;
	padding: 12px;
	font-size: 10px;
	min-width: 61px;
	overflow: hidden;
	display: none;
	align-items: center;
	text-decoration: none;
`;
const Image = styled.img`
	max-width: 130px;
`;
const HeaderLogoContainer = styled.div``;
const HeaderTextContainer = styled.div``;
const HeaderText = styled.h4`
	font-size: 16px;
	font-weight: 900;
	margin-bottom: 6px;
	margin-left: 15px;
	color: ${(props) => props.headerColor || "#ffffff"};
	${mediaMaxWidth.medium`
		display: ${(props) => (props.hideHeaderTitleOnMobile ? "none" : "block")}
	`}
`;
const HeaderLogoTextContainer = styled.div`
	display: flex;
	align-items: center;
`;

const HeaderContainer = styled.div`
	border-bottom: ${(props) => (props.headerSeperator ? "1px solid grey" : "none")};
	padding: 15px;
	background-color: ${(props) => props.bgColor || "#4d3951"};
	${mediaMaxWidth.small`
		&#share-post-header-desktop-view {
			display: none;
		}
        & ${HeaderTextContainer}  {
			& ${HeaderText} {
				font-size: 10px;
				font-weight: 800;
				margin-bottom: 6px;
				margin-left: 8px;
				margin-right: 8px;
				text-align: left;
			}
        }
        & ${Image} {
            max-width: 105px;
        }
        & ${HeaderLogoContainer} {
            & svg {
				// width: 45px;
                height: 45px;
                border-radius: 9px;
            }  
		}
		& ${HeaderPlayStoreLogoContainer} {
			& ${PlayStoreLink} {
				display: none;
			}
			& ${GetAppButton} {
				display: flex;
			}
		}
    `}
	${({ bgColor }) =>
		bgColor
			? css`
					${mediaMaxWidth.medium`
			background-color: ${bgColor};
		`}
			  `
			: css`
					${mediaMaxWidth.medium`
			background-color: #fff;
		`}
			  `}
`;

const MainContainer = styled.header`
	${({ sticky }) => {
		if (sticky) {
			return css`
				position: sticky;
				top: 0;
				z-index: 10;
			`;
		}
	}}
`;

export default Header;
